export const LOAN_DISCLOSURE_COPY =
  'You do not need to disclose alimony, child support, or separate maintenance income if you do not wish to have it considered as a basis for repaying this loan.';

export const CREDIT_DISCLOSURE_COPY =
  'You do not need to disclose alimony, child support, or separate maintenance income if you do not wish to have it considered as a basis for this line of credit.';
